<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-form
          ref="form"
          v-model="isFormValid"
        >
          <v-container fluid>
            <v-row>
              <BasicDateField
                :date="edited.opened"
                label="Open Date *"
                outlined
                required
                :rules="[rules.required]"
                @update-date="newDate => updateOpenDateField(newDate)"
                @valid-changed="value => setOpenDateValidation(value)"
              />

              <v-col
                v-if="recordSchemeHasAlphabet"
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="edited.public_id_alphabet"
                  outlined
                  required
                  :hint="recordScheme.alphabetHint"
                  persistent-hint
                  label="Record Public ID Alphabet *"
                  :rules="[rules.required, rules.recordPublicId('alphabet', localRecord.public_id_alphabet)]"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { dateISOFormat } from '@/utilities'
import { rules } from '@/utilities/validation-rules'

import { RECORD_NAMESPACE } from '@/store/record'
import { SHARED_NAMESPACE } from '@/store/shared'

import BasicDateField from '@/components/Fields/BasicDate.vue'

export default {
  name: 'RecordEditorOverview',

  components: {
    BasicDateField,
  },

  props: {
    valid: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      openDateValid: false,
      rules: {
        ...rules,
        recordPublicId: null,
      },
    }
  },

  computed: {
    isFormValid: {
      get () { return this.valid },
      set (val) { this.$emit('update:valid', val) },
    },

    recordSchemeHasAlphabet () {
      let result = false
      if (this.recordSchemeIsSetUp) {
        if (this.recordSchemeSettings.all_user_values) result = this.recordSchemeSettings.all_user_values.scheme.includes('alphabet')
        else if (this.recordSchemeSettings.value) {
          const value = JSON.parse(this.recordSchemeSettings.value)
          result = value.scheme.includes('alphabet')
        }
      }

      return result
    },

    recordSchemeIsSetUp () {
      return this.recordSchemeSettings &&
        Object.keys(this.recordSchemeSettings).length > 0
    },

    recordSchemeSettings () {
      return this.features?.record_public_id_scheme
    },

    ...mapGetters(RECORD_NAMESPACE, [
      'edited',
    ]),

    ...mapGetters(SHARED_NAMESPACE, [
      'features',
    ]),

  },

  created () {
    if (!this.edited.opened) this.edited.opened = dateISOFormat()
    this.defineValidationRules()
    this.getFeatures()
  },

  methods: {
    defineValidationRules () {
      this.rules.recordPublicId = (key, publicId) => {
        let isValid = true
        let errorMessage = ''

        if (publicId && this.recordSchemeIsSetUp) {
          const schemeInfo = this.recordSchemeSettings.all_user_values
          const schema = schemeInfo[key]
          const validationRule = schema.regex
          const re = new RegExp(validationRule)
          const outcome = re.exec(publicId)
          if (!outcome) {
            errorMessage = schema.errorMessage
            isValid = false
          }
        } else {
          errorMessage = 'Public ID validation not set. Admin > Settings > Records'
          isValid = false
        }

        return isValid || errorMessage
      }
    },

    setOpenDateValidation (value) {
      this.openDateValid = !!(this.edited.opened && value)
    },

    updateOpenDateField (newDate) {
      this.edited.opened = newDate
    },

    validate () {
      if (!this.openDateValid) {
        this.isFormValid = false
        return
      } else this.isFormValid = true
      this.$refs.form.validate()
    },

    ...mapActions(SHARED_NAMESPACE, [
      'getFeatures',
    ]),
  },
}
</script>
